import { createContext, useContext } from 'react';

interface FooterContextType {
    isSidebarCollapsed: boolean;
    setSidebarCollapsed: (collapsed: boolean) => void;
}

export const FooterContext = createContext<FooterContextType>({
    isSidebarCollapsed: false,
    setSidebarCollapsed: () => { },
});

export const useFooter = () => useContext(FooterContext);
